export default "__VITE_ASSET__DdZcv0iW__"